import { useEffect, useRef } from 'react';
import { DomainSearchGateModule } from '../domainSearchGate.module';
import { useIsInView } from '../../hooks/useIsInView';
const IMPRESSION_THRESHOLD = 0.5;
export const useTldStripImpression = _ref => {
  let domain = _ref.domain,
    sld = _ref.sld,
    componentName = _ref.componentName,
    pageNumber = _ref.pageNumber,
    tlds = _ref.tlds,
    enabled = _ref.enabled;
  const ref = useRef(null);
  const isInView = useIsInView(ref, {
    enabled,
    threshold: IMPRESSION_THRESHOLD
  });
  const reportedRef = useRef({
    pages: new Set()
  });
  const tldsKey = tlds.join(',');
  useEffect(() => {
    if (!enabled || !sld || !isInView) {
      return;
    }
    const reported = reportedRef.current;
    if (reported.domain !== domain) {
      reported.domain = domain;
      reported.pages = new Set();
    }
    if (reported.pages.has(pageNumber)) {
      return;
    }
    reported.pages.add(pageNumber);
    DomainSearchGateModule.internals.bi.onTldStripViewed == null || DomainSearchGateModule.internals.bi.onTldStripViewed({
      componentName,
      sld,
      pageNumber,
      tlds: tldsKey
    });
  }, [enabled, sld, isInView, domain, pageNumber, componentName, tldsKey]);
  return ref;
};
//# sourceMappingURL=useTldStripImpression.js.map